import { createSelector, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

interface CalendarState {
  currentDate: string; // Store as ISO string for serialization
}

const initialState: CalendarState = {
  currentDate: DateTime.now().toISO(),
};

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    setCurrentDate: (state, action: PayloadAction<string>) => {
      state.currentDate = action.payload;
    },
  },
});

export const { setCurrentDate } = calendarSlice.actions;
export default calendarSlice.reducer;

/// Base selector to get the ISO string
const selectCurrentDateISO = (state: any) => state.calendar.currentDate;

// Memoized selector that converts to DateTime
export const selectCurrentDate = createSelector([selectCurrentDateISO], (dateISO: string) =>
  DateTime.fromISO(dateISO),
);
